import builder from '../builder';
import Search1 from '../../streamline-icons/bold/search-1.svg';

export default builder('IconSearch1Bold', Search1);
